var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"overlay",staticClass:"overlay",class:{'overlay--open' : _vm.overlayOpen},on:{"click":function($event){return _vm.closeOverlay()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }